import { BugleIcon } from './BugleIcon';

/**
 * author: Michael Irigoyen
 * id CBC37A12-44AA-4CA8-976A-F26ED26849D4
 * name bugle
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bugle.svg
 * tags
 * - Automotive 
 * - Music 
 */
export const CarHornIcon = BugleIcon;
export default CarHornIcon